import React from 'react';
import CopyTextWithTooltip from './CopyTextWithTooltip';
import { ClipboardIcon } from '@heroicons/react/24/outline';

export default function CopyElement({ text }) {
  return (
    <div className="inline-flex w-auto max-w-full truncate">
      <CopyTextWithTooltip text={text}>
        <div className="flex gap-x-1 items-center">
          <span className="font-medium text-gray-800 dark:text-foreground hover:bg-gray-50 dark:hover:bg-muted transition-colors px-1 py-0 gap-x-2 items-center rounded truncate">
            {text}
          </span>

          <div className="flex-1">
            <ClipboardIcon className="w-4 h-4" />
          </div>
        </div>
      </CopyTextWithTooltip>
    </div>
  );
}
